import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiV2 } from '@heviton/heviton-api-v2';
import { fromRawAgreement } from '@/shared/data-mappers';
import type { Agreement, AgreementCode } from '@/shared/data-types';

/** 약관 query key — code 별. invalidate/prefetch 가 공유하는 SSOT. */
export const agreementQueryKey = (code: AgreementCode) => ['agreement', code] as const;

/**
 * 약관 query 정의 SSOT (queryKey + queryFn). v2 agreement 호출 → `fromRawAgreement` 순수 변환.
 * BE 응답 invariant 검증 없음 (ADR `domain-ssot` §5). staleTime 은 default — 약관은 거의
 * 불변이라 도메인 캐시 정책 정립 시 장기 staleTime 후보.
 */
export const agreementQueryOptions = (api: HevitonApiV2, code: AgreementCode) =>
  queryOptions<Agreement>({
    queryKey: agreementQueryKey(code),
    queryFn: async ({ signal }) => fromRawAgreement(await api.agreement.byType(code, { signal })),
  });
